import apiRequest from "./apiRequest";
import lang from "src/lang";
import { SelectType } from "../types";
import debounce from "lodash/debounce";
import * as Icons from "@ant-design/icons";

import { message } from "antd";
import { getCookie } from "./cookies";

class coreFunctions {
  static waitRequest(arg0: number) {
    throw new Error("Method not implemented.");
  }
  static convertNumberToWords(num: number): string {
    if (num === 0) return "Zero";

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const scales = [
      "",
      "Thousand",
      "Million",
      "Billion",
      "Trillion",
      "Quadrillion",
      "Quintillion",
      "Sextillion",
      "Septillion",
      "Octillion",
      "Nonillion",
      "Decillion",
    ];

    const isNegative = num < 0;
    num = Math.abs(num);

    let words = [];
    let scaleIndex = 0;

    while (num > 0) {
      const chunk = num % 1000;
      num = Math.floor(num / 1000);

      if (chunk !== 0) {
        let chunkWords = [];
        const hundreds = Math.floor(chunk / 100);
        const remainder = chunk % 100;

        if (hundreds > 0) {
          chunkWords.push(`${ones[hundreds]} Hundred`);
        }

        if (remainder > 0) {
          if (remainder < 20) {
            chunkWords.push(ones[remainder]);
          } else {
            const ten = Math.floor(remainder / 10);
            const unit = remainder % 10;
            chunkWords.push(
              unit === 0
                ? tens[ten]
                : `${tens[ten]}-${ones[unit].toLowerCase()}`
            );
          }
        }

        if (scaleIndex > 0) {
          chunkWords.push(scales[scaleIndex]);
        }

        words.unshift(chunkWords.join(" "));
      }

      scaleIndex++;
    }

    let result = words.join(" ");

    // Handle cases where we might have multiple spaces
    result = result.replace(/\s+/g, " ").trim();

    return isNegative ? `Negative ${result}` : result;
  }
  makeStrongPassword() {
    const pregs =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ@#$%^&*abcdefghijklmnopqrstuvwxyz0123456789";

    let password = "";
    for (let i = 0; i < 12; i++) {
      password += pregs.charAt(Math.floor(Math.random() * pregs.length));
    }

    return password;
  }

  static formatToDateTime(input: string, timeOnly: boolean = false) {
    const cleanInput = input.trim().replace(/\s+/g, "");
    const date = new Date(cleanInput);

    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const pad = (num: any) => String(num).padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    if (timeOnly) {
      return `${hours}:${minutes}:${seconds}`;
    }
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  formatISODateTime(
    isoString: string,
    onlydate: boolean = false,
    time: boolean = false
  ) {
    const date = new Date(isoString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    if (onlydate) {
      return `${year}-${month}-${day}`;
    }

    if (time) {
      return `${hours}:${minutes}:${seconds}`;
    }

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  getTimeDuration(start: string, end: string = new Date().toISOString()) {
    const start_dt = new Date(start);
    const end_dt = new Date(end);
    const diff = end_dt.getTime() - start_dt.getTime();
    const hours = Math.floor(diff / 1000 / 60 / 60);
    const minutes = Math.floor(diff / 1000 / 60) - hours * 60;
    const seconds = Math.floor(diff / 1000) - hours * 60 * 60 - minutes * 60;

    return `${hours}:${minutes}:${seconds}`;
  }

  waitTimePromise = async (time: number = 100) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, time);
    });
  };

  async waitRequest(time: number = 100) {
    await this.waitTimePromise(time);
  }

  async searchOptions(
    value: string,
    module: string,
    type: string,
    callback: (data: any[]) => void,
    parms?: any,
    loadingCallback?: (loading: boolean) => void
  ) {
    const handleSearch = debounce(async () => {
      const SEARCH_REQUEST = new apiRequest(module + "/search", true);

      await SEARCH_REQUEST.send(
        { type: type, value: value, ...parms },
        (data: { status: string; message: string; data: SelectType[] }) => {
          if (data.status === "success") {
            callback(data.data);
          }
        }
      );
    }, 100);

    if (typeof loadingCallback === "function") loadingCallback(true);
    await handleSearch();
    if (typeof loadingCallback === "function") loadingCallback(false);
  }

  castStringToNumber(variable: any) {
    switch (typeof variable) {
      case "number":
        return variable;
      case "string":
        let coverted_number = parseFloat(variable);
        return isNaN(coverted_number) ? 0 : coverted_number;
      case undefined:
        return 0;
      default:
        return 0;
    }
  }

  static renderIcon(iconName?: string, props = {}): JSX.Element | undefined {
    const IconComponent = iconName ? (Icons as any)[iconName] : null;
    return IconComponent ? <IconComponent {...props} /> : undefined;
  }

  getFileFormat(mime_type: string) {
    switch (mime_type) {
      case "image/png":
        return "image";
      case "image/jpeg":
        return "image";
      case "image/gif":
        return "image";
      case "image/webp":
        return "image";
      case "text/csv":
        return "document";
      case "application/pdf":
        return "document";
      default:
        return "document";
    }
  }

  static hasToken() {
    return localStorage.getItem("token") ? true : false;
  }

  static async deleteFile(hash: string, callback?: () => void) {
    const API_REQUEST = new apiRequest("file/delete", true);
    await API_REQUEST.send(
      { hash: hash },
      (data: { status: string; message: string }) => {
        if (data.status === "success") {
          if (callback) callback();
          message.success(lang.get("", [data.message]), 2);
        } else {
          message.error(lang.get("", [data.message]), 2);
        }
      }
    );
  }

  static async hasInternetConnection() {
    try {
      const API_REQUEST = new apiRequest("health_check/connection");
      const response = await API_REQUEST.send();

      if (response.status === "success") return true;

      return false;
    } catch (error) {
      return false;
    }
  }

  static isTokenExpiredRedirect = () => {
    const token = localStorage.getItem("token");
    const tokenExpired = localStorage.getItem("token_expired");
    const { origin, href, pathname } = window.location;

    if (tokenExpired) {
      localStorage.removeItem("token_expired");

      if (pathname !== "/" && !href.includes("expired")) {
        window.location.href = "/expired";
        return;
      }
    }

    if (
      !token &&
      href !== origin &&
      pathname !== "/" &&
      !href.includes("expired")
    ) {
      localStorage.clear();
      window.location.href = "/";
    }
  };

  static forceRedirect = (redirect_to = "/", clear_local_storage = true) => {
    const { origin, href, pathname } = window.location;

    const excludedPaths = [
      /^\/modules\/sales\/invoice\/view\/[A-Za-z0-9=+/_-]+$/,
    ];

    const isExcluded = excludedPaths.some((regex) => regex.test(pathname));

    if (!isExcluded && href !== origin && pathname !== "/") {
      if (clear_local_storage) localStorage.clear();
      window.location.href = redirect_to;
    }
  };

  static isMobileDevice = () => {
    return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|webOS/i.test(
      navigator.userAgent
    );
  };

  static isiOS = (): boolean => {
    return (
      ["iPad", "iPhone", "iPod"].includes(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  static formatCurrency(value: string | number): string {
    const num = Number(value);
    if (isNaN(num)) return "0";

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }

  static bytesToSize(bytes: number): string {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    if (bytes === 0) return "n/a";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString());
    return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i];
  }

  static hasNewVersion(callback: (data?: any) => void) {
    const API_REQUEST = new apiRequest("health_check/version", true);
    API_REQUEST.send(
      {
        version: getCookie("version") || 0,
        device: coreFunctions.isMobileDevice(),
      },
      (data: { status: string; data: any }) => {
        if (data.status === "success") {
          callback(data.data);
        }
      }
    );
  }
}

export default coreFunctions;
